import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

/* Service for managing and observing state using BehaviorSubjects. */
export class StoreService {

  private stateMap: Map<string, BehaviorSubject<any>> = new Map();

  constructor() {}

  public setState(key: string, value: any): void {
    if(!this.stateMap.has(key)) {
      this.stateMap.set(key, new BehaviorSubject(value));
      return;
    }
    const stateSubject = this.stateMap.get(key);
    if(!stateSubject) return;
    stateSubject.next(value);
  }

  public getStateObservable(key: string): Observable<any> {
    const stateSubject = this.stateMap.get(key);
    if(!stateSubject) return EMPTY;
    return stateSubject.asObservable();
  }

  public deleteState(key: string): void {
    const stateSubject = this.stateMap.get(key);
    if(!stateSubject) return;
    stateSubject.complete();
    this.stateMap.delete(key);
  }

  public deleteAllStates(): void {
    this.stateMap.forEach((value, key) => {
      value.complete();
    });
    this.stateMap.clear();
  }
}